"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressModal = exports.AddressSchema = void 0;
var react_1 = __importStar(require("react"));
var yup = __importStar(require("yup"));
var layout_1 = require("../layout");
var ValidatedState_1 = require("../validation/ValidatedState");
var Label_1 = require("../labels/Label");
var TextInput_1 = require("../inputs/TextInput");
var Select_1 = require("../controls/Select");
var Focus_1 = require("../labels/Focus");
exports.AddressSchema = yup.object({
    addressLine1: yup.string().required('Street number and name is required').defined('Street number and name is required'),
    suburb: yup.string().required('Suburb is required').defined('Suburb is required'),
    state: yup.string().required('State is required').defined('State is required'),
    postCode: yup.string().required('Post code is required').defined('Post code is required'),
    country: yup.string().required('Country is required').defined('Country is required'),
});
var AddressModal = function (props) {
    var _a = (0, ValidatedState_1.useValidatedState)(__assign({}, props.value), exports.AddressSchema), value = _a[0], setValue = _a[1], errors = _a[2], validate = _a[3];
    (0, react_1.useEffect)(function () {
        if (value != props.value) {
            setValue(__assign({}, props.value), ValidatedState_1.ValidationHint.ClearValidation);
        }
    }, [props.value]);
    var onChange = function () {
        validate("#".concat(props.id)).then(function (res) {
            if (res) {
                props.onChange(value);
                props.onClose();
            }
        });
    };
    var countryOptions = (0, react_1.useMemo)(function () {
        var res = [];
        if (!props.countryStates) {
            return res;
        }
        for (var c in props.countryStates) {
            res.push({ label: c, value: c });
        }
        res.sort(function (a, b) {
            if (a > b) {
                return 1;
            }
            else if (a < b) {
                return -1;
            }
            else {
                return 0;
            }
        });
        return res;
    }, [props.countryStates]);
    var stateOptions = (0, react_1.useMemo)(function () {
        var res = [];
        if (!props.countryStates) {
            return res;
        }
        if (value.country && value.country in props.countryStates) {
            res = props.countryStates[value.country].map(function (r) { return ({ label: r, value: r }); });
        }
        res.sort(function (a, b) {
            if (a > b) {
                return 1;
            }
            else if (a < b) {
                return -1;
            }
            else {
                return 0;
            }
        });
        return res;
    }, [value.country, props.countryStates]);
    (0, react_1.useEffect)(function () {
        if (props.countryStates) {
            setValue({ state: '' }, ValidatedState_1.ValidationHint.NoValidation);
        }
    }, [value.country]);
    return (react_1.default.createElement(layout_1.Modal, { title: "Enter address", id: props.id, open: props.open, onClose: props.onClose, onOpened: function () { return (0, Focus_1.autoFocus)("#".concat(props.id)); }, rightButtons: [
            { label: 'OK', onClick: onChange },
            { label: 'Close', onClick: props.onClose, mode: 'secondary' },
        ] },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement(Label_1.Label, { label: "Street number and name", id: "".concat(props.id, "-addressLine1"), error: errors.addressLine1, required: true },
                    react_1.default.createElement(TextInput_1.TextInput, { size: "block", value: value.addressLine1 || '', onChange: function (v) { return setValue({ addressLine1: v }); } })))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-6" },
                react_1.default.createElement(Label_1.Label, { className: "mt-2", label: "Suburb", id: "".concat(props.id, "-suburb"), required: true, error: errors.suburb },
                    react_1.default.createElement(TextInput_1.TextInput, { size: "block", value: value.suburb || '', onChange: function (v) { return setValue({ suburb: v }); } }))),
            react_1.default.createElement("div", { className: "col-md-6" },
                react_1.default.createElement(Label_1.Label, { className: "mt-2", label: "Post code", id: "".concat(props.id, "-postCode"), error: errors.postCode, required: true },
                    react_1.default.createElement(TextInput_1.TextInput, { size: "block", value: value.postCode || '', onChange: function (v) { return setValue({ postCode: v }); } })))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-6" },
                react_1.default.createElement(Label_1.Label, { className: "mt-2", label: "Country", id: "".concat(props.id, "-country"), error: errors.country, required: true }, props.countryStates ? (react_1.default.createElement(Select_1.Select, { value: value.country ? value.country : null, onChange: function (v) { return setValue({ country: v ? v : '' }); }, options: countryOptions, defaultLabel: "Select..." })) : (react_1.default.createElement(TextInput_1.TextInput, { size: "block", value: value.country || '', onChange: function (v) { return setValue({ country: v }); } })))),
            react_1.default.createElement("div", { className: "col-md-6" },
                react_1.default.createElement(Label_1.Label, { className: "mt-2", label: "State", id: "".concat(props.id, "-state"), error: errors.state, required: true }, props.countryStates ? (react_1.default.createElement(Select_1.Select, { value: value.state ? value.state : null, onChange: function (v) { return setValue({ state: v ? v : '' }); }, options: stateOptions, defaultLabel: "Select..." })) : (react_1.default.createElement(TextInput_1.TextInput, { size: "block", value: value.state || '', onChange: function (v) { return setValue({ state: v }); } })))))));
};
exports.AddressModal = AddressModal;
//# sourceMappingURL=AddressModal.js.map